import { useAppDispatch, useAppSelector } from "../../redux/store/hooks"
import { useEffect } from "react"
import PatientList from "../../component/dashboard_general/PatientList"
import ValueTypeList from "../../component/dashboard_data/ValueTypeList"
import LinkingRequestsList from "../../component/dashboard_general/LinkingRequestsList"
import OneTimePasswortInfo from "../../component/dashboard_general/OneTimePasswortInfo"
import CurrentDataView from "../../component/dashboard_data/CurrentDataView"
import DataViewPreferences from "../../component/dashboard_data/DataViewPreferences"
import BaselineDataView from "../../component/dashboard_data/BaselineDataView"
import {
    selectDashboardSelectedPatient,
    selectDashboardSelectedValueType
} from "../../redux/ProfessionalDashboard"
import { dispatchThunk } from "../../redux/thunk/thunkify"
import {
    GetPatientDataBaselineSpecification,
    GetPatientDataCurrentSpecification
} from "pokal_api"
import TrendEstimationView from "../../component/dashboard_data/TrendEstimationView"
import LatestDataView from "../../component/dashboard_data/LatestDataView"
import DashboardWrapper from "../../component/DashboardWrapper"

function DataDashboardView() {
    const dispatch = useAppDispatch()
    const selectedPatient = useAppSelector(selectDashboardSelectedPatient)
    const selectedValueType = useAppSelector(selectDashboardSelectedValueType)

    useEffect(() => {
        if (selectedPatient !== null && selectedValueType !== null) {
            dispatchThunk(dispatch, GetPatientDataCurrentSpecification, {
                patient: selectedPatient.id,
                valueType: selectedValueType
            })
            dispatchThunk(dispatch, GetPatientDataBaselineSpecification, {
                patient: selectedPatient.id,
                valueType: selectedValueType
            })
        }
    }, [selectedPatient, selectedValueType])

    return (
        <DashboardWrapper>
            <div className={"w-full flex flex-col space-y-4"}>
                <div className={"w-full flex space-x-4"}>
                    <div className={"flex-1 flex flex-col space-y-4"}>
                        <PatientList />
                        <LinkingRequestsList />
                        <OneTimePasswortInfo />
                    </div>
                    <div className={"flex-2"}>
                        <ValueTypeList />
                    </div>
                </div>
                <div className={"w-full flex space-x-4"}>
                    <div className={"flex-1 flex flex-col w-full"}>
                        <TrendEstimationView />
                    </div>
                    <div className={"flex-3 flex flex-col w-full"}>
                        <CurrentDataView />
                    </div>
                    <div className={"flex flex-col w-full flex-1 space-y-4"}>
                        <LatestDataView />
                        <div className={"flex-1 flex flex-col"}>
                            <DataViewPreferences />
                        </div>
                    </div>
                </div>
                <BaselineDataView />
            </div>
        </DashboardWrapper>
    )
}

export default DataDashboardView
